/* src/app/components/list-popover/list-popover.component.scss */
ion-list {
  cursor: pointer;
  padding: 0;
}
ion-list ion-item:last-child {
  --border-style: none;
}
/*# sourceMappingURL=list-popover.component.css.map */
